
let styles = {
  container: {
    padding: '3%',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: '#dcdcdc',
    padding: '1%',
  },

  items: {
    padding: '1%',
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '1%',
  },

  item_body: {
    padding: '6px',
  },

  final_sums: {
    // padding: '1%',
    fontWeight: 600,
    paddingTop: '1%',
  },

  col_sum: {
    paddingLeft: '1%',
    fontWeight: 600,
    paddingTop: '1%',
  },

  main_header: {
    padding: '1%',
    marginBottom: '3%',
    backgroundColor: '#32B6A7',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  input: {
    width: '80%',
  },

  item_table: {
    backgroundColor: '#dcdcdc',
    padding: '1%',
    paddingTop: '6%',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editTarget/style.js